@import "@/scss/use-bootstrap-mixins.scss";

.pricingTable {
  border: 1px solid #dedede;
  width: 100%;
  padding: 0;
  margin: 0;
  border-spacing: 0;

  thead {
    background-color: $primary;

    tr {
      th {
        padding: 0;
        margin: 0;
        color: $textColorOnPrimary !important;
        font-weight: 400 !important;
        padding: 7px 10px;
        text-align: left !important;
        background-color: $primary;

        @include media-breakpoint-up(md) {
          padding: 13px 10px;
        }

        &:first-of-type {
          text-align: left !important;
        }

        &:last-of-type {
          text-align: right !important;
        }
      }

      .desktop {
        @include media-breakpoint-down(lg) {
          display: none;
        }
      }
    }
  }

  tbody {
    background-color: #fff;

    svg {
      width: 100%;
    }

    tr {
      td {
        padding: 4px 6px;
        color: #000;
        opacity: 0.8;
        font-size: 14px;
        text-align: left !important;

        @include media-breakpoint-up(md) {
          padding: 10px;
          font-size: 16px;
        }

        &:first-of-type {
          text-align: left !important;
        }

        &:last-of-type {
          text-align: right !important;
        }

        .discountName {
          display: block;
          font-size: 12px;
          opacity: 0.7;

          @include media-breakpoint-up(md) {
            font-size: 13px;
          }
        }

        .chargePeriod {
          display: inline-block;
          margin-left: 0.4em;
          font-size: 12px;
          opacity: 0.7;
          white-space: nowrap;

          @include media-breakpoint-up(md) {
            font-size: 13px;
          }
        }
      }

      .desktop {
        @include media-breakpoint-down(lg) {
          display: none;
        }
      }
    }
  }

  tfoot {
    background-color: #fff;
    tr {
      td {
        border-top: 1px solid #dedede;
        padding: 8px;

        &:last-of-type {
          text-align: right !important;
          padding: 4px;

          @include media-breakpoint-up(md) {
            padding: 10px;
          }
        }
      }

      .desktop {
        @include media-breakpoint-down(lg) {
          display: none;
        }
      }
    }
  }
}
